export default "__VITE_ASSET__SlfydQTa__"